import { normalize, schema } from 'normalizr';
import {
  Application,
  Article,
  ContactNode,
  CorporatePass,
  Enrolment,
  Membership,
  Voucher
} from '@api';
import { WaitingList } from '@api';
import { PurchaseItem } from 'src/js/model/index';
import { ContactProps } from '../components/Index';

const SEnrolments = new schema.Entity('enrolments', {}, {
  idAttribute: (e: Enrolment) => `${e.contactId}-${e.classId || e.courseId}`,
});
const SApplications = new schema.Entity('applications', {}, {
  idAttribute: (a: Application) => `${a.contactId}-${a.classId}`,
});
const SMemberships = new schema.Entity('memberships', {}, {
  idAttribute: (m: Membership) => `${m.contactId}-${m.productId}`,
});
const SArticles = new schema.Entity('articles', {}, {
  idAttribute: (a: Article) => `${a.contactId}-${a.productId}`,
});
const SVouchers = new schema.Entity('vouchers', {}, {
  idAttribute: (v: Voucher) => `${v.contactId}-${v.productId}`,
});
const SWaitingLists = new schema.Entity('waitingLists', {}, {
  idAttribute: (v: WaitingList) => `${v.contactId}-${v.courseId}`,
});

const SContactNodes = new schema.Entity('contactNodes', {
  enrolments: [SEnrolments],
  applications: [SApplications],
  memberships: [SMemberships],
  articles: [SArticles],
  vouchers: [SVouchers],
  waitingLists: [SWaitingLists],
},
{
  idAttribute: 'contactId',
  mergeStrategy: (a) => a
});

const Schema = new schema.Array(SContactNodes);

export interface ContactNodeStorage {
  contactId?: string;
  enrolments?: string[];
  applications?: string[];
  vouchers?: string[];
  articles?: string[];
  memberships?: string[];
  waitingLists?: string[];
}
export interface ContactNodesStorage {
  [key: string]: ContactNodeStorage;
}

export interface State {
  result: string[];
  entities: {
    enrolments: { [key: string]: Enrolment }
    applications: { [key: string]: Application }
    vouchers: { [key: string]: Voucher }
    articles: { [key: string]: Article }
    memberships: { [key: string]: Membership }
    contactNodes: ContactNodesStorage;
    waitingLists: { [key: string]: WaitingList }
  };
  resultDetails?: {
    corporatePass?: CorporatePass;
    contacts?: ContactProps[];
    amountPayed?: number;
  },
  fetching?: boolean;
}

export const ContactNodeToState = (input: ContactNode[]): State => normalize(input, Schema);

export const ItemToState = (input: PurchaseItem): State => {
  const node: ContactNode = {
    contactEmail: '',
    contactFirstName: '',
    contactLastName: '',
    contactId: input.contactId,
    enrolments: input instanceof Enrolment ? [input] : [],
    applications: input instanceof Application ? [input] : [],
    memberships: input instanceof Membership ? [input] : [],
    articles: input instanceof Article ? [input] : [],
    vouchers: input instanceof Voucher ? [input] : [],
    waitingLists: input instanceof WaitingList ? [input] : []
  }
  return ContactNodeToState([node]);
};
